export default __webpack_public_path__ + "static/media/wallet-token-congrats.605883fc.png";